// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__NcCoz","inner":"style_inner__1AtVX","bottom":"style_bottom__2zd5Y","copyright":"style_copyright__18NH4"};